import { DownloadableBlobNode } from "./DownloadableBlobNode.js";
import { UrlNode } from "./UrlNode.js";

/**
 * @description Factory that allows easy creation of FileNodes
 * @returns { FileNode } A new FileNode
 * */
export class FileNodeFactory {
    /**
     * @description Creates a new FileNode from an instance object
     * @param { ProjectData.Instance } instance
     * @returns { FileNode }
     */
    static createFromInstance(instance) {
        let publicWebUrl = instance.publicWebUrl;
        let isWebLink = instance.referenceData.publicWebUrl !== undefined;

        /* [ CASE 1: ] Non-downloadable file (cdurl, obj, fbx...); any file that has a "publicWebUrl" in their relative path */
        if (isWebLink) {
            let fileName = null;

            if (instance.fileName !== null && instance.fileName !== undefined && instance.fileName !== "") {
                fileName = instance.fileName;
            }

            /* [ Fallback ] */
            if (fileName === null || fileName === "") {
                fileName = instance.referenceData.relativePath
                    .split('\\').pop()
                    .split('/').pop();
            }

            let end = fileName.lastIndexOf(".");

            if (end < 0) {
                end = fileName.length;
            }

            fileName = fileName.substr(0, end) + ".url";

            return new UrlNode(fileName, publicWebUrl);
        }

        /*
         * [ CASE 2: ] Downloadable file (pdf, jpg, mp4...), the download will occur later
         * 
         * [ ! ] The file fetches its name in the download phase; it will ALWAYS have a name
         */

        return new DownloadableBlobNode(null, publicWebUrl);
    }
}
